import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../../hooks/useLang';
import { useAuthContext } from '../../hooks/useAuthContext';
import '../../styles/components/Footer.scss';

const Footer = () => {
    const { language } = useLang();
    const { user } = useAuthContext();
    const year = new Date().getFullYear();

    return (
        <footer className="site-footer">
            <div className="footer-content">
                <div className="footer-brand">
                    <span className="footer-logo">YeniDers</span>
                    <p>
                        Azerbaijan's home for student notes, study materials, and AI-powered
                        learning tools. Share what you know, learn what you don't.
                    </p>
                </div>

                <div className="footer-links">
                    <div className="footer-column">
                        <h4>Product</h4>
                        {!user && <Link to={`/${language}#features`}>Features</Link>}
                        {!user && <Link to={`/${language}#ai-tools`}>AI Tools</Link>}
                        <Link to={`/${language}/library`}>Library</Link>
                        <Link to={`/${language}/events`}>Events</Link>
                    </div>

                    <div className="footer-column">
                        <h4>Company</h4>
                        <Link to={`/${language}/about`}>About us</Link>
                        <Link to={`/${language}/contact`}>Contact us</Link>
                        <Link to={`/${language}/careers`}>Careers</Link>
                    </div>

                    <div className="footer-column">
                        <h4>Legal</h4>
                        <Link to={`/${language}/privacy`}>Privacy Policy</Link>
                        <Link to={`/${language}/terms`}>Terms of Service</Link>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <span>&copy; {year} YeniDers. All rights reserved.</span>
                <span>Baku, Azerbaijan 🇦🇿</span>
            </div>
        </footer>
    );
};

export default Footer;
